import { Component, OnInit } from '@angular/core';
import { NOTAS_MOCK } from '../_models/mock-data';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { NgClass } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FiltroModule } from 'src/app/_tools/filtro.module';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-notas-tabla',
  templateUrl: 'notas-tabla.component.html',
  styleUrls: ['notas-tabla.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    MatTableModule,
    FiltroModule,
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    MatOptionModule,
    MatToolbarModule,

  ],
})
export class NotasTablaComponent implements OnInit {
  displayedColumns: string[] = ['nombreEstudiante', 'nombreMateria', 'notaPeriodo1', 'porcentajePeriodo1', 'notaPeriodo2', 'porcentajePeriodo2', 'notaAcumulada'];
  dataSource = new MatTableDataSource<any>();

  constructor() { }

  ngOnInit(): void {
    const flatData = NOTAS_MOCK.flatMap(estudiante =>
      estudiante.materias.map(materia => ({
        nombreEstudiante: estudiante.nombre,
        nombreMateria: materia.nombre,
        notaPeriodo1: materia.notaPeriodo1,
        porcentajePeriodo1: materia.porcentajePeriodo1,
        notaPeriodo2: materia.notaPeriodo2,
        porcentajePeriodo2: materia.porcentajePeriodo2,
        notaAcumulada: materia.notaAcumulada
      }))
    );
    this.dataSource.data = flatData;
  }
}
